import { C } from "../../constants/theme";

export function Card({ children, style, ...rest }) {
  return (
    <div
      {...rest}
      style={{
        background: C.card,
        borderRadius: 16,
        padding: 16,
        boxShadow: "var(--pc-card-shadow, 0 2px 8px rgba(0,0,0,0.35), 0 1px 2px rgba(0,0,0,0.25))",
        border: "1px solid var(--pc-card-border, rgba(255,255,255,0.04))",
        ...style
      }}>
      {children}
    </div>
  );
}
